module.exports = __webpack_public_path__ + "img/system_bg.5e95e6ff.png";